<div class="tr">
  <mat-progress-bar *ngIf="loading || busy" mode="indeterminate"></mat-progress-bar>
  <div *ngIf="error" class="tr__error">{{ error }}</div>

  <mat-card class="tr__card">
    <h2 class="tr__title"><mat-icon>percent</mat-icon> County TDT tax rates</h2>
    <p class="tr__muted">The generation engine reads these effective-dated rows. Rate is a
      decimal (0.04 = 4%). Adding an open-ended rate auto-closes the prior one for that county.</p>

    <table mat-table [dataSource]="rates" class="tr__table" *ngIf="rates.length; else empty">
      <ng-container matColumnDef="county">
        <th mat-header-cell *matHeaderCellDef>County</th>
        <td mat-cell *matCellDef="let r">{{ r.county }}</td>
      </ng-container>
      <ng-container matColumnDef="rate">
        <th mat-header-cell *matHeaderCellDef>Rate</th>
        <td mat-cell *matCellDef="let r">{{ pct(r.rate) }} <span class="tr__dim">({{ r.rate }})</span></td>
      </ng-container>
      <ng-container matColumnDef="effectiveFrom">
        <th mat-header-cell *matHeaderCellDef>Effective from</th>
        <td mat-cell *matCellDef="let r">{{ r.effectiveFrom }}</td>
      </ng-container>
      <ng-container matColumnDef="effectiveTo">
        <th mat-header-cell *matHeaderCellDef>Effective to</th>
        <td mat-cell *matCellDef="let r">{{ r.effectiveTo || '—' }}</td>
      </ng-container>
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let r">
          <button mat-icon-button color="warn" (click)="remove(r)"><mat-icon>delete</mat-icon></button>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="columns"></tr>
      <tr mat-row *matRowDef="let row; columns: columns"></tr>
    </table>
    <ng-template #empty><p class="tr__muted" *ngIf="!loading">No tax rates yet.</p></ng-template>
  </mat-card>

  <mat-card class="tr__card">
    <h2 class="tr__title"><mat-icon>add</mat-icon> Add a rate</h2>
    <div class="tr__form">
      <mat-form-field appearance="outline">
        <mat-label>County</mat-label>
        <input matInput [(ngModel)]="draft.county" placeholder="Putnam">
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Rate (decimal)</mat-label>
        <input matInput type="number" step="0.0001" [(ngModel)]="draft.rate" placeholder="0.04">
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Effective from</mat-label>
        <input matInput type="date" [(ngModel)]="draft.effectiveFrom">
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Effective to</mat-label>
        <input matInput type="date" [(ngModel)]="draft.effectiveTo">
      </mat-form-field>
      <button mat-flat-button color="primary" [disabled]="busy" (click)="add()">Add</button>
    </div>
  </mat-card>
</div>
